import { DefaultTheme } from 'styled-components'

import { COLORS } from '../constants/colors'

const DEFAULT_THEME = {
  colors: COLORS,
}

export const themeColors: DefaultTheme = DEFAULT_THEME
